import { createEffect } from '../utils/create-effect';

export interface ClearCellsEffectDeps {
  /**
   * Mode-aware resolver: returns entry/field IDs for the current selection,
   * expanding row selections to all visible entries and column selections to
   * all visible fields.
   */
  resolveSelectionToIds: () => { entryIds: string[]; fieldIds: string[] };
  onClearValues: (entryIds: string[], fieldIds: string[]) => void;
}

/**
 * Executes an approved clear-values request against the current resolved
 * selection. The reducer owns permission policy; this effect owns ID resolution
 * and the database mutation. An empty selection is ignored.
 */
export const createClearCellsEffect = createEffect(
  ({ resolveSelectionToIds, onClearValues }: ClearCellsEffectDeps) => {
    return {
      deltaTypes: ['clearCellsRequested'],

      onDelta(_delta, _state) {
        const { entryIds, fieldIds } = resolveSelectionToIds();

        // Both empty means nothing is selected.
        if (entryIds.length === 0 && fieldIds.length === 0) {
          return;
        }

        onClearValues(entryIds, fieldIds);
      }
    };
  }
);
